// extracted by mini-css-extract-plugin
module.exports = {"logo":"component_logo__2oiTe","form":"component_form__1_vV7","failed":"component_failed__1oLZE"};